export enum ConstructionBuildingProcedureType {
  ZGRADA = 1,
  GRADEVINA = 2,
  ZAHVAT = 3
}
